import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-botonera',
  templateUrl: './botonera.component.html',
  styleUrls: ['./botonera.component.css']
})
export class BotoneraComponent implements OnInit {
  @Input() botones:string[] = [];

  @Output() anclarClick:EventEmitter<number> = new EventEmitter();
  @Output() borrarClick:EventEmitter<number> = new EventEmitter();
  @Output() cancelarClick:EventEmitter<number> = new EventEmitter();
  @Output() cobrarClick:EventEmitter<number> = new EventEmitter();
  @Output() codigoBarrasClick:EventEmitter<number> = new EventEmitter();
  @Output() csvClick:EventEmitter<number> = new EventEmitter();
  @Output() descargarClick:EventEmitter<number> = new EventEmitter();
  @Output() devolucionClick:EventEmitter<number> = new EventEmitter();
  @Output() facturaeClick:EventEmitter<number> = new EventEmitter();
  @Output() facturarClick:EventEmitter<number> = new EventEmitter();
  @Output() grabarClick:EventEmitter<number> = new EventEmitter();
  @Output() importarClick:EventEmitter<number> = new EventEmitter();
  @Output() imprimirClick:EventEmitter<number> = new EventEmitter();
  @Output() inicioClick:EventEmitter<number> = new EventEmitter();
  @Output() irParcelaClick:EventEmitter<number> = new EventEmitter();
  @Output() mailClick:EventEmitter<number> = new EventEmitter();
  @Output() nuevoClick:EventEmitter<number> = new EventEmitter();
  @Output() pantallaClick:EventEmitter<number> = new EventEmitter();
  @Output() recalcularClick:EventEmitter<number> = new EventEmitter();
  @Output() recetasClick:EventEmitter<number> = new EventEmitter();
  @Output() regaloClick:EventEmitter<number> = new EventEmitter();
  @Output() subfamiliaClick:EventEmitter<number> = new EventEmitter();
  @Output() ticketClick:EventEmitter<number> = new EventEmitter();
  @Output() transporteClick:EventEmitter<number> = new EventEmitter();
  @Output() volverClick:EventEmitter<number> = new EventEmitter();
  @Output() whatsAppClick:EventEmitter<number> = new EventEmitter();

  public moduloAgro: boolean = environment.moduloAgro;
  public activarTicketRegalo: boolean = environment.activarTicketRegalo;

  constructor() { }

  ngOnInit(): void {
  }

 

  anclar(){
    this.anclarClick.emit(0);
  }

  borrar(){
    this.borrarClick.emit(0);
  }

  cancelar(){
    this.cancelarClick.emit(0);
  }

  cobrar(){
    this.cobrarClick.emit(0);
  }

  codigoBarras(){
    this.codigoBarrasClick.emit(0);
  }

  csv(){
    this.csvClick.emit(0);
  }

  descargar(){
    this.descargarClick.emit(0);
  }

  devolucion(){
    this.devolucionClick.emit(0);
  }

  facturae(){
    this.facturaeClick.emit(0);
  }

  facturar(){
    this.facturarClick.emit(0);
  }

  grabar(){
    this.grabarClick.emit(0);
  }

  importar(){
    this.importarClick.emit(0);
  }

  imprimir(){
    this.imprimirClick.emit(0);
  }

  inicio(){
    this.inicioClick.emit(0);
  }

  irParcela(){
    this.irParcelaClick.emit(0);
  }

  mail(){
    this.mailClick.emit(0);
  }

  nuevo(){
    this.nuevoClick.emit(0);
  }

  pantalla(){
    this.pantallaClick.emit(0);
  }

  subfamilia(){
    this.subfamiliaClick.emit(0);
  }

  recalcular(){
    this.recalcularClick.emit(0);
  }

  recetas(){
    this.recetasClick.emit(0);
  }

  regalo(){
    this.regaloClick.emit(0);
  }

  ticket(){
    this.ticketClick.emit(0);
  }

  transporte(){
    this.transporteClick.emit(0);
  }

  volver(){
    this.volverClick.emit(0);
  }

  whatsApp(){
    this.whatsAppClick.emit(0);
  }

}
